import { useState } from "react";
import {
  FaBalanceScale,
  FaUserMd,
  FaUsers,
  FaGavel,
  FaFileAlt,
  FaUserTie,
  FaHandsHelping,
} from "react-icons/fa";
import { X_PADDING } from "../constants";
import Page from "./Page";
import Section from "./Section";

const ProfessionalPractice = () => {
  return (
    <Page name="Professional Practice">
      <div className="w-full pt-8 bg-white">
        {/* Scope of Clinical Practice */}
        <Section
          name="Scope of Clinical Practice"
          description="Patients in Primary Health care facilities deserve care led by Clinical practitioners—the most highly educated, trained and skilled health care professionals at such levels. Through research, advocacy and education, the COAZ vigorously defends the Clinical practice against scope-of-practice expansions that threaten patient safety."
        />

        {/* Explore More */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-[#16365c]">Explore More</h2>

            <p className="text-[#7c8a97] mt-3 max-w-3xl mx-auto">
              Understanding the distinct responsibilities of healthcare
              professionals promotes collaboration while ensuring patients
              receive safe, high-quality clinical care.
            </p>

            <div className="w-16 h-1 bg-[#1b9de3] mx-auto mt-4 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <InfoCard
              icon={<FaUserMd size={42} />}
              title="Clinical Officers"
              points={[
                "Highly trained in clinical diagnosis and treatment.",
                "Lead patient care at primary healthcare facilities.",
                "Provide comprehensive clinical assessment.",
                "Support quality, safe and evidence-based healthcare.",
              ]}
            />

            <InfoCard
              icon={<FaUsers size={42} />}
              title="Non-Clinical Providers"
              points={[
                "Essential members of the healthcare team.",
                "Support healthcare delivery within defined professional roles.",
                "Work collaboratively with Clinical Officers.",
                "Help improve access to healthcare services.",
              ]}
            />
          </div>
          <p className="text-[#7c8a97] text-sm text-center max-w-3xl mx-auto mt-8 italic">
            It's easier than ever for patients and the public to get confused
            about who does what in Zambia's health care system — and mixed up
            about what distinguishes a Clinician's training and skill from that
            of other health professionals.
          </p>
        </div>

        {/* Whats at stack */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="flex flex-col lg:w-2/3 h-fit space-y-8">
              <div className="flex flex-col w-full h-fit space-y-4">
                <h2 className="text-2xl font-bold text-[#16365c]">
                  What's at Stake
                </h2>
                <p className="text-[#7c8a97]">
                  There is room for improvement in the Zambia health system but
                  allowing non clinicians such as nurse practitioners (NPs) or
                  Community health practitioners to diagnose and treat patients,
                  especially at primary health care levels and secondary health
                  care levels without any physician oversight is a step in the
                  wrong direction. The best way to support high-quality care and
                  lower costs is to keep clinicians as the leader of the health
                  care teams.
                </p>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 w-full h-fit gap-4 overflow-hidden">
                <EquityFeatureCard
                // change titles 
                  title="Coming Soon"
                  description="Zambian people in underserved areas deserve better health care services. COAZ is 
                         advocating for Changes in the Human resources Establishment at all primary health 
                         care and secondary health care levels to reflect the current health care needs, 
                         especially in clinical care services. "
                  active={true}
                />
                <EquityFeatureCard
                  title="Coming Soon"
                  description="Clinicians are highly trained in diagnostics. Nurse practitioners and axillary 
                         providers have a limited scope to provide comprehensive care services. They 
                         require clinical guidance from Clinicians. "
                />
              </div>
            </div>

            {/* Right side */}
            <div className="lg:w-1/3 bg-[#eef7fd] rounded-lg p-6 shadow-sm">
               {/* change the blue back ground just put a big fontented 63% */}
              <div className="h-32 bg-gradient-to-r from-[#1b9de3] to-[#16365c] rounded-md mb-4 flex items-center justify-center text-white text-sm font-semibold">
                63%
              </div>
              <h3 className="text-lg font-bold text-[#16365c] mb-2">
                {" "}
                Hospital Cancer Cases
              </h3>
              <p className="text-[#7c8a97] text-sm mb-4">
                There is substantive evidence in diagnostic gaps. The University
                teaching Hospital cancer diseases Hospital, in 2023 presented
                that 63% of all cancer cases received at CDH are in 63%. This
                shows that there is a GAP in diagnostics in Primary care sites.
              </p>
            </div>
          </div>
        </div>

        {/* COAZ Position */}

        <div className={`${X_PADDING} w-full mx-auto pb-14`}>
          <div className="border border-[#eef1f4] rounded-lg p-8 bg-white shadow-sm">
            <div className="flex items-center gap-3 mb-5">
              <FaBalanceScale className="text-[#1477c2]" size={24} />
              <h2 className="text-2xl font-bold text-[#16365c]">
                The COAZ Position
              </h2>
            </div>

            <p className="text-[#7c8a97] leading-8 mb-4">
              Patients deserve care led by Clinical Officers—the most highly
              educated, trained and skilled healthcare professionals in primary
              healthcare. COAZ actively protects clinical practice against
              inappropriate scope-of-practice expansion while promoting safe,
              accessible and quality healthcare for every Zambian.
            </p>

            <p className="text-[#7c8a97] leading-8">
              COAZ advocates for Truth in Advertising campaigns to ensure
              patients can clearly identify Clinical Officers and understand
              their qualifications. We believe all healthcare professionals
              should be required to accurately disclose their training and
              credentials to patients, fostering transparency and trust in the
              healthcare system.
            </p>
          </div>
        </div>

        {/* Advocacy in Action Section */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-[#16365c]">
              COAZ Advocacy in Action
            </h2>
            <p className="text-[#7c8a97] text-sm text-center max-w-3xl mx-auto mt-8 italic">
              In strong collaboration with clinical professional society
              partners, COAZ has successfully advocated for policy changes that
              strengthen the Clinical Officer profession and improve healthcare
              delivery nationwide.
            </p>
            <div className="w-16 h-1 bg-[#1f8fd1] mx-auto mt-4 rounded"></div>
          </div>

          <div className="flex flex-col lg:flex-row gap-8">
            {/* Left side - Image with overlay square */}
            <div className="lg:w-2/5 relative">
              <div className="relative rounded-lg overflow-hidden shadow-lg h-[400px] lg:h-[500px]">
                {/* Main Image */}
                <img
                  src="/images/img_15.jpg"
                  alt="COAZ Advocacy"
                  className="w-full h-full object-cover"
                />

                {/* Square on Top Right - Like 1985 style */}
               {/*  change the 2023 pplicy change look */} 
                <div className="absolute top-0 right-0 bg-[#55a2dc] w-24 h-24 rounded-lg flex flex-col items-center justify-center shadow-lg">
                  <span className="text-white text-2xl font-bold">2023</span>
                  <span className="text-white/80 text-[10px] font-semibold uppercase tracking-wider">
                    Policy Change
                  </span>
                </div>
              </div>
            </div>

            {/* Right side - Title and Grid */}
            <div className="lg:w-3/5 space-y-6">
              <h3 className="text-xl font-bold text-[#16365c]">
                Our Advocacy Achievements
              </h3>

              <div className="grid grid-cols-2 gap-4">
                <AdvocacyGridItem
                  icon={<FaGavel className="text-[#1b9de3]" size={20} />}
                  title="Policy Change"
                  text="Clinical Anaesthetist & Ophthalmic practitioners mandate transferred to HPCZ"
                />
                <AdvocacyGridItem
                  icon={<FaFileAlt className="text-[#1b9de3]" size={20} />}
                  title="New Registers"
                  text="Opened registers for BSc Clinical Medicine: Mental Health, Ophthalmology, Anaesthesia"
                />
                <AdvocacyGridItem
                  icon={<FaUserTie className="text-[#1b9de3]" size={20} />}
                  title="New Positions"
                  text="Created senior clinical officer posts including Principal (H) and Clinical Care (K)"
                />
                <AdvocacyGridItem
                  icon={<FaHandsHelping className="text-[#1b9de3]" size={20} />}
                  title="Collaboration"
                  text="Strong partnerships with clinical professional societies across Zambia"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Advocacy Priorities */}
         <div className={`${X_PADDING} w-full mx-auto pb-16`}>
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-[#16365c]">
              What COAZ is Pushing For
            </h2>
            <p className="text-[#7c8a97] mt-3">
              COAZ continues advocating for policies that strengthen the
              Clinical Officer profession and improve healthcare delivery
              nationwide.
            </p>
            <div className="w-16 h-1 bg-[#1477c2] mx-auto mt-4 rounded-full"></div>
          </div>

          <div className="border border-[#eef1f4] rounded-lg p-8 bg-white shadow-sm">
            <ul className="text-[#7c8a97] space-y-3">
              <PriorityPoint
                text="Pushing the Ministry of Health and HPCZ to reject implementation of 
                inappropriate scope of practice expansions."
              />
              <PriorityPoint
                text="The ministry of health to develop the National standards of practice for all 
                Health care providers in Zambia."
              />
              <PriorityPoint
                text="For an annual publishing of a Health workforce Mapping data by the 
                Ministry of Health to Health in Health workforce distribution planning and 
                recruitment. "
              />
              <PriorityPoint
                text="Review current scope of practice for non-clinician practitioners and state 
                boundaries."
              />
              <PriorityPoint
                text="Establishing degree salaries for members holding bachelors degrees and 
                more."
              />
              <PriorityPoint
                text="Training of MSc programs in Critical areas such as Dermatology, Cancer 
                disease, ENT, Anaesthesia etc."
              />
              <PriorityPoint
                text="Creation of Bridging Programs for Medical Licentiates into MBChB and 
                advancing into MSc Clinical Medicine programs. "
              />
            </ul>
          </div>
        </div>

        {/* CTA Banner */}
        <div className="bg-[#1477c2] py-10">
          <div
            className={`${X_PADDING} w-full mx-auto flex flex-col md:flex-row items-center justify-between gap-4`}
          >
            <h2 className="text-white text-2xl font-semibold">
              Join the Advocacy for Clinical Practice
            </h2>
            <button className="bg-white text-[#1477c2] px-8 py-3 rounded-full font-semibold hover:bg-[#eef7fd] transition">
              Get Involved
            </button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default ProfessionalPractice;

// Advocacy Card Component
/* const AdvocacyCard = ({ title, description }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="border border-[#eef1f4] rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <h4
        className={`text-base font-bold mb-3 transition-colors ${hover ? "text-[#1477c2]" : "text-[#16365c]"}`}
      >
        {title}
      </h4>
      <p className="text-[#7c8a97] text-sm mb-3">{description}</p>
      {achievement && (
        <div className="flex items-center gap-2 text-sm text-[#1477c2] font-semibold">
          <span>{achievement}</span>
        </div>
      )} 
    </div>
  );
}; */

// Advocacy Grid Item Component
const AdvocacyGridItem = ({ icon, title, text }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={`border rounded-lg p-4 transition-all duration-300 cursor-default ${
        hover
          ? "border-[#1477c2] shadow-md bg-[#f8fafb]"
          : "border-[#eef1f4] bg-white"
      }`}
    >
      <div className="flex flex-col">
        <div className="mb-2">{icon}</div>
        <h4
          className={`text-sm font-bold mb-1 transition-colors ${
            hover ? "text-[#1477c2]" : "text-[#16365c]"
          }`}
        >
          {title}
        </h4>
        <p className="text-[#7c8a97] text-xs leading-relaxed">{text}</p>
      </div>
    </div>
  );
};

// Push Item Component
/* const PushItem = ({ text }) => {
  return (
    <div className="flex items-start gap-3 p-3 bg-[#f8fafb] rounded-lg hover:bg-[#eef7fd] transition-colors">
      <span className="text-[#1b9de3] font-bold text-lg leading-none mt-0.5">
        •
      </span>
      <p className="text-[#7c8a97] text-sm">{text}</p>
    </div>
  );
}; */

const InfoCard = ({ icon, title, points, active = false }) => {
  const highlighted = active;

  return (
    <div
      className={`border rounded-xl p-8 transition-all duration-300 cursor-default
      ${
        highlighted
          ? "bg-[#1477c2] border-[#1477c2] text-white shadow-lg"
          : "bg-white border-[#eef1f4]"
      }`}
    >
      <div className={`mb-5 ${highlighted ? "text-white" : "text-[#1477c2]"}`}>
        {icon}
      </div>

      <h3
        className={`text-xl font-bold mb-4 ${
          highlighted ? "text-white" : "text-[#16365c]"
        }`}
      >
        {title}
      </h3>

      <ul className="space-y-3">
        {points.map((item, index) => (
          <li
            key={index}
            className={`text-sm leading-7 ${
              highlighted ? "text-white" : "text-[#7c8a97]"
            }`}
          >
            • {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

/* const PositionItem = ({ title, description }) => (
  <div className="bg-white rounded-lg p-5 shadow-sm">
    <h4 className="font-bold text-[#16365c] mb-2">{title}</h4>

    <p className="text-[#7c8a97] text-sm">{description}</p>
  </div>
);
 */
const PriorityPoint = ({ text }) => {
  return (
    <li className="flex items-start gap-3 p-3 bg-white rounded-lg ">
      <span className="text-[#1b9de3] font-bold text-lg leading-none mt-0.5">
        •
      </span>
      <span className="text-[#16365c] text-sm ">{text}</span>
    </li>
  );
};

const EquityFeatureCard = ({ title, description }) => {
  const [highlighted, setHighlighted] = useState(false);

  return (
    <div className="w-full h-48">
      <div
        onMouseEnter={() => setHighlighted(true)}
        onMouseLeave={() => setHighlighted(false)}
        className={`feature  flex flex-col space-y-2 items-center p-6 hover:text-white overflow-hidden rounded-lg transition-all duration-300 ${
          highlighted
            ? "bg-[#1477c2] text-white shadow-md"
            : "bg-[#eef7fd] text-[#16365c]"
        }`}
      >
        <h4
          className={`text-base font-bold text-center transition-colors duration-300 ${
            highlighted ? "text-white" : "text-[#16365c]"
          }`}
        >
          {title}
        </h4>
        <p
          className={`text-xs text-center transition-colors duration-300 ${
            highlighted ? "text-white/85" : "text-[#7c8a97]"
          }`}
        >
          {description}
        </p>
      </div>
    </div>
  );
};
